const EnclosurePreview = ({ type, hingePosition = 'left', doorPosition = 'left' }) => {
  const isHingeRight = hingePosition === 'right';
  const isDoorRight = doorPosition === 'right';

  const svgs = {
    'single-door': (
      <svg viewBox="0 0 100 165" className="w-full h-full max-h-48">
        <rect x="20" y="10" width="60" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="22" y="12" width="56" height="116" fill="#00bcd4" fillOpacity="0.1" />
        <rect x={isHingeRight ? "76" : "20"} y="30" width="4" height="10" fill="#666" />
        <rect x={isHingeRight ? "76" : "20"} y="90" width="4" height="10" fill="#666" />
        <circle cx={isHingeRight ? "30" : "70"} cy="70" r="4" fill="#00bcd4" />
        <text x="50" y="155" textAnchor="middle" fontSize="9" fill="#666">Door</text>
      </svg>
    ),
    'door-panel': isDoorRight ? (
      <svg viewBox="0 0 150 165" className="w-full h-full max-h-48">
        <rect x="10" y="10" width="40" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="12" y="12" width="36" height="116" fill="#00bcd4" fillOpacity="0.05" />
        <rect x="55" y="10" width="60" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="57" y="12" width="56" height="116" fill="#00bcd4" fillOpacity="0.1" />
        <rect x={isHingeRight ? "111" : "55"} y="30" width="4" height="10" fill="#666" />
        <rect x={isHingeRight ? "111" : "55"} y="90" width="4" height="10" fill="#666" />
        <circle cx={isHingeRight ? "65" : "105"} cy="70" r="4" fill="#00bcd4" />
        <text x="30" y="155" textAnchor="middle" fontSize="9" fill="#666">Panel</text>
        <text x="85" y="155" textAnchor="middle" fontSize="9" fill="#666">Door</text>
      </svg>
    ) : (
      <svg viewBox="0 0 150 165" className="w-full h-full max-h-48">
        <rect x="10" y="10" width="60" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="12" y="12" width="56" height="116" fill="#00bcd4" fillOpacity="0.1" />
        <rect x={isHingeRight ? "66" : "10"} y="30" width="4" height="10" fill="#666" />
        <rect x={isHingeRight ? "66" : "10"} y="90" width="4" height="10" fill="#666" />
        <circle cx={isHingeRight ? "20" : "60"} cy="70" r="4" fill="#00bcd4" />
        <rect x="75" y="10" width="40" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="77" y="12" width="36" height="116" fill="#00bcd4" fillOpacity="0.05" />
        <text x="40" y="155" textAnchor="middle" fontSize="9" fill="#666">Door</text>
        <text x="95" y="155" textAnchor="middle" fontSize="9" fill="#666">Panel</text>
      </svg>
    ),
    'door-two-panels': (
      <svg viewBox="0 0 200 165" className="w-full h-full max-h-48">
        <rect x="10" y="10" width="35" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="12" y="12" width="31" height="116" fill="#00bcd4" fillOpacity="0.05" />
        <rect x="50" y="10" width="60" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="52" y="12" width="56" height="116" fill="#00bcd4" fillOpacity="0.1" />
        <rect x={isHingeRight ? "106" : "50"} y="30" width="4" height="10" fill="#666" />
        <rect x={isHingeRight ? "106" : "50"} y="90" width="4" height="10" fill="#666" />
        <circle cx={isHingeRight ? "60" : "100"} cy="70" r="4" fill="#00bcd4" />
        <rect x="115" y="10" width="35" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="117" y="12" width="31" height="116" fill="#00bcd4" fillOpacity="0.05" />
        <text x="27" y="155" textAnchor="middle" fontSize="8" fill="#666">Panel</text>
        <text x="80" y="155" textAnchor="middle" fontSize="8" fill="#666">Door</text>
        <text x="132" y="155" textAnchor="middle" fontSize="8" fill="#666">Panel</text>
      </svg>
    ),
    '90-degree': (
      <svg viewBox="0 0 150 150" className="w-full h-full max-h-48">
        <line x1="15" y1="15" x2="130" y2="15" stroke="#999" strokeWidth="5" />
        <line x1="15" y1="15" x2="15" y2="125" stroke="#999" strokeWidth="5" />
        <line x1="18" y1="122" x2="125" y2="122" stroke="#00bcd4" strokeWidth="4" />
        <line x1="125" y1="18" x2="125" y2="122" stroke="#00bcd4" strokeWidth="4" />
        <rect x="18" y="18" width="107" height="104" fill="#00bcd4" fillOpacity="0.06" />
        <text x="70" y="140" textAnchor="middle" fontSize="9" fill="#555">Panel</text>
        <text x="140" y="72" textAnchor="start" fontSize="9" fill="#555">Door</text>
        <text x="75" y="10" textAnchor="middle" fontSize="7" fill="#aaa">Top-Down View</text>
      </svg>
    ),
    'neo-angle': (
      <svg viewBox="0 0 150 150" className="w-full h-full max-h-48">
        <line x1="15" y1="15" x2="130" y2="15" stroke="#999" strokeWidth="5" />
        <line x1="15" y1="15" x2="15" y2="125" stroke="#999" strokeWidth="5" />
        <line x1="125" y1="18" x2="125" y2="48" stroke="#00bcd4" strokeWidth="4" />
        <line x1="125" y1="48" x2="50" y2="122" stroke="#00bcd4" strokeWidth="4" />
        <line x1="50" y1="122" x2="18" y2="122" stroke="#00bcd4" strokeWidth="4" />
        <polygon points="18,18 125,18 125,48 50,122 18,122" fill="#00bcd4" fillOpacity="0.06" />
        <text x="34" y="140" textAnchor="middle" fontSize="8" fill="#555">Side 1</text>
        <text x="98" y="95" textAnchor="start" fontSize="8" fill="#555">Door</text>
        <text x="134" y="38" textAnchor="start" fontSize="8" fill="#555">Side 2</text>
        <text x="75" y="10" textAnchor="middle" fontSize="7" fill="#aaa">Top-Down View</text>
      </svg>
    ),
    'sliding': (
      <svg viewBox="0 0 180 165" className="w-full h-full max-h-48">
        <rect x="10" y="10" width="160" height="120" fill="none" stroke="#00bcd4" strokeWidth="2" />
        <rect x="15" y="15" width="75" height="110" fill="#00bcd4" fillOpacity="0.1" stroke="#00bcd4" strokeWidth="1" />
        <rect x="85" y="15" width="75" height="110" fill="#00bcd4" fillOpacity="0.05" stroke="#00bcd4" strokeWidth="1" strokeDasharray="5,5" />
        <line x1="10" y1="8" x2="170" y2="8" stroke="#666" strokeWidth="3" />
        <circle cx="80" cy="70" r="4" fill="#00bcd4" />
        <path d="M 100 65 L 130 65 M 125 60 L 130 65 L 125 70" stroke="#666" strokeWidth="2" fill="none" />
        <text x="52" y="155" textAnchor="middle" fontSize="9" fill="#666">Fixed</text>
        <text x="122" y="155" textAnchor="middle" fontSize="9" fill="#666">Sliding</text>
      </svg>
    ),
  };

  return (
    <div className="bg-white rounded-lg p-4 flex items-center justify-center">
      {svgs[type] || null}
    </div>
  );
};

export default EnclosurePreview;
